import {createFileRoute} from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_protected/home/accounts/one-time-credit/$accountId',
)({
  staticData: {crumbKey: 'navigation.invoices'},
});
